import { BaseObject} from './BaseObject';

export class PerfilModel extends BaseObject{
}